import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-auth-homepage',
  templateUrl: './auth-homepage.component.html',
  styleUrls: ['./auth-homepage.component.scss']
})
export class AuthHomepageComponent implements AfterViewInit {
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;

  showDelivery: boolean = false;
  showCollection : boolean = false;
  showReports : boolean = false;
  showInvoices: boolean = false;
  showReservations: boolean = false;
  showGeneral: boolean = false;

  constructor(private observer: BreakpointObserver, private router: Router) { }

  ngAfterViewInit() {
    this.observer
      .observe(['(max-width: 800px)'])
      .pipe(delay(1))
      .subscribe((res) => {
        if (res.matches) {
          this.sidenav.mode = 'over';
          this.sidenav.close();
        } else {
          this.sidenav.mode = 'side';
          this.sidenav.open();
        }
      });
  }

  showEditDelivery()
  {
    this.showNone();
    this.showDelivery = true;
  }

  showEditCollection()
  {
    this.showNone();
    this.showCollection = true;
  }

  showReportsPage()
  {
    this.showNone();
    this.showReports = true;
  }

  showInvoicesPage()
  {
    this.showNone();
    this.showInvoices = true;
  }

  showReservationsPage()
  {
    this.showNone();
    this.showReservations = true;
  }

  showGeneralPage()
  {
    this.showNone();
    this.showGeneral = true;
  }

  showNone()
  {
    this.showGeneral = false;
    this.showReservations = false;
    this.showInvoices = false;
    this.showDelivery = false;
    this.showCollection = false;
    this.showReports = false;
  }

}
